/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Mon Mar 18 2024
 **/

import { useTheme } from "@emotion/react";
import { Icon, Row, Typography } from "@/frameworks/designStuff/components";

import { SwitchCase } from "@/frameworks/libraries/components";
import { _T } from "@rfice/language";

type CallLogItemProps = {
	callType: string;
	callReceiveTime: string;
	callTime: string;
};

export default function CallLogItem({ callType, callReceiveTime, callTime }: CallLogItemProps) {
	const { colors } = useTheme();

	return (
		<Row verticalAlign="center" gap={12} css={{ marginTop: 12 }}>
			<SwitchCase
				condition={callType}
				cases={{
					// 수신 전화
					ACCEPTED: <Icon name="CallIncoming24" size={20} fill={colors.neutral_50_80} />,
					// 발신 전화
					REQUESTED: <Icon name="CallOutgoing24" size={20} fill={colors.neutral_50_80} />,
					// 부재중 전화 (내가 안받은 전화)
					ENDED: <Icon name="CallMissed24" size={20} fill={colors.error_60_100} />,
					// 미착신 발신 전화
					REJECTED: <Icon name="CallUnanswered24" size={20} fill={colors.warning_50_100} />,
					HANGUP_NO_RESPONSE: <Icon name="CallUnanswered24" size={20} fill={colors.warning_50_100} />,
					ENDED_BY_DEVICE_DISCONNECTED: (
						<Icon name="CallUnanswered24" size={20} fill={colors.warning_50_100} />
					)
				}}
				defaultCase={<div style={{ width: "20px", height: "20px" }} />}
			/>
			<Typography css={{ width: 80 }} typoSize="Title1_B" typoColor="neutral_70_100">
				{callReceiveTime}
			</Typography>
			<Typography typoSize="Body3" typoColor="neutral_70_100">
				{callType === "REJECTED" || callType === "HANGUP_NO_RESPONSE"
					? _T("수신 {{number}}초", { number: 0 })
					: callTime}
			</Typography>
		</Row>
	);
}
